module.exports = {"pathContext":{"name":"AgedArReportStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Report data is cached and ready","isDeprecated":false,"name":"READY"},{"deprecationReason":null,"description":"Report generation is in progress","isDeprecated":false,"name":"RUNNING"},{"deprecationReason":null,"description":"Report cannot be generated due to overlapping batch job","isDeprecated":false,"name":"UNAVAILABLE"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-aged-ar-report-status.json
// module id = 1204
// module chunks = 249983792257848